import {
	ChangeDetectionStrategy,
	Component,
	input,
	output,
	ViewEncapsulation,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { MarkdownComponent } from 'ngx-markdown';

import { cn } from '@valk-nx/core/lib/core';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

import type { SelectionCardInterface } from '../selection-card.interface';

@Component({
	selector: 'vp-selection-card-input',
	imports: [MarkdownComponent, SVG_ICON_IMPORTS, TranslatePipe],
	templateUrl: './selection-card-input.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SelectionCardInputComponent {
	controlType = input<'radio' | 'checkbox'>('radio');
	hasCardsAsMarkdown = input<boolean>(false);
	hasError = input<boolean>(false);
	isDisabled = input<boolean>(false);
	isReadonly = input<boolean>(false);
	isSelected = input<boolean>(false);
	name = input<string>('');
	option = input.required<SelectionCardInterface>();
	stacked = input<boolean>(false);
	hideNativeInput = input<boolean>(false);

	changed = output<string>();

	cn = cn;

	changedValue(id: string): void {
		this.changed.emit(id);
	}
}
